/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Claimant_VehicleInputs */

const en_reports_col_claimant_vehicle = /** @type {(inputs: Reports_Col_Claimant_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimant vehicle`)
};

const pt_br2_reports_col_claimant_vehicle = /** @type {(inputs: Reports_Col_Claimant_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veículo Requerente`)
};

/**
* | output |
* | --- |
* | "Claimant vehicle" |
*
* @param {Reports_Col_Claimant_VehicleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_claimant_vehicle = /** @type {((inputs?: Reports_Col_Claimant_VehicleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Claimant_VehicleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_claimant_vehicle(inputs)
	return pt_br2_reports_col_claimant_vehicle(inputs)
});